<template>
  <v-container fluid>
    <v-flex xs12>
      <v-card class="grey lighten-4 elevation-0">
        <v-card-title class="title">
        <span style="color: gray;"> Для добавления сотрудника отправьте этот код боту с аккаунта ТГ Вашего сотрудника:</span> &nbsp; {{ authcode }}
        <v-spacer></v-spacer>
          <v-btn fab small class="grey" @click.native="cancel()">
            <v-icon>cancel</v-icon>
          </v-btn>
        </v-card-title>
      </v-card>
      <!--v-card class="grey lighten-4 elevation-0">
        <v-card-title class="title">
          <span style="color: gray;">Добавить сотрудника без привязки у аккаунту ТГ:</span>
          <v-spacer></v-spacer>
          <v-flex md4 sm12  class="mx-1 px-0">
          <v-text-field name="nickName" label="Nick Name" maxlength="20" hint="Nick name is required" value="Input text" v-model="nickname" class="input-group--focused" required></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-btn fab small class="purple" @click.native="save()" :disabled="nickname.length < 6">
            <v-icon>save</v-icon>
          </v-btn>
        </v-card-title>
      </v-card-->
    </v-flex>
  </v-container>
</template>
<script>
/* global Store */
// import Table from "@/components/Table.vue";
import { mapState, dispatch } from 'vuex'
import auth from '../utils/auth'
export default {
//  components: {
//    Table,
//  },
  data() {
    return {
      nickname: '',
      title: '',

      }
    },
    methods: {
      save() {
        Store.dispatch('workers/addWorker', this.nickname);
        this.$router.push({ name: 'Workers' })
      },
      cancel() {
        this.$router.push({ name: 'Workers' })
      },
    },
    created() {
      let authcode = Math.floor(Math.random() * (9000 - 1000) + 1000);
      let r1 = Math.floor(authcode / 1000);
      let r2 = Math.floor(authcode / 100) - r1 * 10;
      let r3 = Math.floor(authcode / 10) - r1 * 100 - r2 * 10;
      let r4 = authcode - r1 * 1000 - r2 * 100 - r3 * 10;
      this.authcode = authcode * 100 + (r1 + r2 + r3 + r4 + 2);
      if (!this.$route.params.id){
        auth.link(this.authcode, (loggedIn, err) => {
          if (err) {
            console.log('login', err)
            this.error = true
            this.text = err
          } else if (loggedIn === false) {
            console.log('login', loggedIn)
            this.error = true
            this.text = 'Bad login information'
          } else {
            console.log(this.$route)
            this.$router.push(this.$route.query.redirect || '/')
          }
        })
      }
    },
    mounted() {
    }
  }
</script>



// WEBPACK FOOTER //
// WorkerForm.vue?6232f1b0